<svg width="26" height="26" viewBox="0 0 120 120">
	<circle cx="60" cy="60" r="54" [attr.fill]="background" stroke="#e6e6e6" [attr.stroke-width]="strokeWidth" />
	<circle class="outer" [attr.stroke-dasharray]="100" attr.stroke-dashoffset="calc(100 - {{perc}})" cx="60" cy="60"
		r="54" fill="none" stroke="#4d4d4d" [attr.stroke-width]="strokeWidth" pathLength="100" stroke-linecap="round">
	</circle>
</svg>
